import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-actions',
  standalone: true,
  templateUrl: './card-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-actions.component.css',
})
export class CardActionsComponent {}
